import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, InputNumber, notification, Select, AutoComplete, Col} from 'antd';

import {addProductToPurchaseOrder, getPurchaseOrder} from './actions';
import {getProducts} from "../Product/actions";
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout, formItemLayoutFullWidth} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

const styles = {
  hideOverflow: {
    overflow: 'hidden',
  }
};

const uuidRegex = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddProductToPurchaseOrderForm extends Component {
  state = {
    filteredProducts: null
  };

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dispensaryId !== this.props.dispensaryId
      || prevProps.match.params.purchaseId !== this.props.match.params.purchaseId) {
      this._load();
    }
    const {purchaseOrder} = this.props;
    const {purchaseOrder: prevPurchaseOrder} = prevProps;
    if (purchaseOrder && prevPurchaseOrder && purchaseOrder.purchaseId !== prevPurchaseOrder.purchaseId) {
      this._loadProducts();
    }
  }

  _loadProducts = (value) => {
    const {purchaseOrder, dispensaryId} = this.props;
    const {supplierId} = purchaseOrder;
    this.props.getProducts({dispensaryId, supplierId, filter: value});
  };

  _onSearchProducts = (value) => {
    if (this._searchProductTimeout) clearTimeout(this._searchProductTimeout);
    this._searchProductTimeout = setTimeout(this._loadProducts, 300, value);
    return false;
  };

  _load = () => {
    const {dispensaryId, getPurchaseOrder, purchaseOrder, getProducts} = this.props;
    const {purchaseId} = decodeParams(this.props.match.params);
    if (dispensaryId) {
      getPurchaseOrder({purchaseId});
    }
    if (purchaseOrder && purchaseOrder.supplierId) {
      const {supplierId} = purchaseOrder;
      getProducts({dispensaryId, supplierId});
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {purchaseId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addProductToPurchaseOrder({...values, purchaseId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, products, purchaseOrder} = this.props;
    const {filteredProducts} = this.state;
    return (
      <Card title="Add Product To Purchase Order">
        <Form onSubmit={e => e.preventDefault()}>
          <FormItem
            {...formItemLayout}
            label="Purchase Order"
          >
            {`${purchaseOrder.supplierName} - ${purchaseOrder.status} (${purchaseOrder.modifiedAt})`}
          </FormItem>
          <FormItem
            {...formItemLayoutFullWidth}
            label="Product"
          >
            {getFieldDecorator('productId', {
              rules: [
                { required: true, pattern: uuidRegex, message: 'Please select a Product' },
              ],
              validateTrigger: ['onSelect', 'onBlur'],
            })(
              <AutoComplete onSearch={this._onSearchProducts} optionLabelProp="text" defaultActiveFirstOption={false}>
                {(filteredProducts || products).map(({productId, brandName, categoryName, display, barcode}) =>
                  <Option key={productId} value={productId} text={display}>
                    <Col span={9} style={styles.hideOverflow}>{display}</Col>
                    <Col span={5} style={styles.hideOverflow}>{categoryName}</Col>
                    <Col span={5} style={styles.hideOverflow}>{brandName}</Col>
                    <Col span={5} style={styles.hideOverflow}>{barcode}</Col>
                  </Option>
                )}
              </AutoComplete>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Quantity"
          >
            {getFieldDecorator('quantity', {
              rules: [
                { required: true, message: 'Please input your Quantity' },
              ]
            })(
              <InputNumber />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Net Cost Per Unit"
          >
            {getFieldDecorator('netCostPerUnit', {initialValue: null})(
              <InputNumber />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="button"
                onClick={this.handleSubmit}
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Product To Purchase Order
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddProductToPurchaseOrderForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  dispensaryId: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  addProductToPurchaseOrder: PropTypes.func.isRequired,
  getPurchaseOrder: PropTypes.func.isRequired,
  purchaseOrder: PropTypes.object.isRequired,
  getProducts: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
};

const AddProductToPurchaseOrderPage = Form.create()(AddProductToPurchaseOrderForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  loading: state.purchaseOrder.purchaseOrderLoading || state.product.productsLoading
    || state.purchaseOrder.addProductToPurchaseOrderLoading,
  purchaseOrder: state.purchaseOrder.purchaseOrder || {},
  products: state.product.products,
});

const mapDispatchToProps = dispatch => ({
  addProductToPurchaseOrder: payload => (dispatch(addProductToPurchaseOrder(payload))),
  getPurchaseOrder: payload => (dispatch(getPurchaseOrder(payload))),
  getProducts: payload => (dispatch(getProducts(payload))),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddProductToPurchaseOrderPage);



// WEBPACK FOOTER //
// ./src/PurchaseOrder/AddProductToPurchaseOrderPage.js